module.exports = __webpack_public_path__ + "img/i-accessory-mono.e6cb3fc6.svg";